import { render, staticRenderFns } from "./FormInput.vue?vue&type=template&id=2d627cb4&scoped=true"
import script from "./FormInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FormInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormInput.vue?vue&type=style&index=0&id=2d627cb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d627cb4",
  null
  
)

export default component.exports